import { render, staticRenderFns } from "./CreateAlertModal.vue?vue&type=template&id=06b9a72f&scoped=true&"
import script from "./CreateAlertModal.vue?vue&type=script&lang=js&"
export * from "./CreateAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateAlertModal.vue?vue&type=style&index=0&id=06b9a72f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b9a72f",
  null
  
)

export default component.exports